<template>
  <div class="notification-preference-partial">
    <template v-if="finishedLoading && record && scopedNotificationPreference">
      <div :key="scopedNotificationPreference.uuid">


        <div class="heading">
          <h3>{{ $t('notificationPreferencePartial.timezoneSelectLabel') }}</h3>
        </div>

        <section class="timezone">
          <div class="notification-preference-partial-dropdown-container" v-if="showTimezone">
            <label :for="`organization-timezone-select-${partialUUID}`">{{ $t('notificationPreferencePartial.timezoneSelectLabel') }}</label>
            <v-select
              :id="`organization-timezone-select-${partialUUID}`"
              v-model="newNotificationPreference.time_zone"
              :options="timeZonesList"
              :clearable="false"
              v-on:input="updateTimeZone"
            />
          </div>
        </section>

        <div class="heading">
          <h3>{{ $t('notificationPreferencePartial.heading') }}</h3>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-${partialUUID}`"
              v-model="newNotificationPreference.enabled"
              switch
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-${partialUUID}`">Enabled</label>
          </fieldset>
        </div>

      <section class="time-notifications">
          <span
            class="notification-preference-partial-subheading">{{
            $t('notificationPreferencePartial.timeNotificationHeading')
          }}</span>
        <div class="notification-preference-partial-time-section">

          <div class="notification-preference-partial-dropdown-container">
            <label :for="`notification-preference-hours-${partialUUID}`">{{
              $t('notificationPreferencePartial.hoursLabel')
              }}</label>
            <v-select
              :id="`notification-preference-hours-${partialUUID}`"
              v-model="selectedHour"
              :options="hours"
              :clearable="false"
              :reduce="obj => obj.value"
              v-on:input="updateMinutesSinceMidnight"
            />
          </div>

          <span>:</span>

          <div class="notification-preference-partial-dropdown-container">
            <label :for="`notification-preference-minutes-${partialUUID}`">{{
              $t('notificationPreferencePartial.minutesLabel')
              }}</label>
            <v-select
              :id="`notification-preference-minutes-${partialUUID}`"
              v-model="selectedMinute"
              :options="minutes"
              :clearable="false"
              :reduce="obj => obj.value"
              v-on:input="updateMinutesSinceMidnight"
            />
          </div>

          <div class="notification-preference-partial-am-or-pm">
            <b-form-radio-group
              :id="`notification-preference-am-or-pm-toggle-${partialUUID}`"
              v-model="selectedPeriod"
              :options="period"
              name="radio-btn-stacked"
              size="sm"
              button-variant="outline-primary"
              @change="updateMinutesSinceMidnight"
              buttons
              stacked
            />
          </div>

        </div>


        <span class="notification-preference-partial-subheading">{{
            $t('notificationPreferencePartial.daysToBeNotify')
          }}</span>
        <section>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-sunday-${partialUUID}`"
              v-model="newNotificationPreference.sunday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-sunday-${partialUUID}`">Sunday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-monday-${partialUUID}`"
              v-model="newNotificationPreference.monday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-monday-${partialUUID}`">Monday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-tuesday-${partialUUID}`"
              v-model="newNotificationPreference.tuesday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-tuesday-${partialUUID}`">tuesday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-wednesday-${partialUUID}`"
              v-model="newNotificationPreference.wednesday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-wednesday-${partialUUID}`">wednesday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-thursday-${partialUUID}`"
              v-model="newNotificationPreference.thursday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-thursday-${partialUUID}`">thursday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-friday-${partialUUID}`"
              v-model="newNotificationPreference.friday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-friday-${partialUUID}`">friday</label>
          </fieldset>
          <fieldset>
            <b-checkbox
              class="notification-checkbox"
              :id="`notification-preference-checkbox-saturday-${partialUUID}`"
              v-model="newNotificationPreference.saturday"
              @change="updatePreference"
            />
            <label :for="`notification-preference-checkbox-saturday-${partialUUID}`">saturday</label>
          </fieldset>
        </section>
      </section>

      </div>
    </template>
    <loading-spinner v-else />
  </div>
</template>

<script>
import localeHandling from '@/mixins/locale-handling';
import commonFunctions from '@/mixins/common';
import commonMemberFunctions from '@/mixins/common-member-functions';
import NotificationPreferenceService from '@/services/notification-preference.service';
import MemberService from '@/services/member.service';
import UserService from '@/services/user.service';
import OrganizationService from '@/services/organization.service';
import _ from 'lodash';
import {uuid} from 'vue-uuid';

export default {
  name: 'NotificationPreferencePartial',
  mixins: [commonFunctions, commonMemberFunctions, localeHandling],
  props: {
    // so you may ask what's the difference
    // The ID is in reference to the object we want to update
    // the notificationPreference is the inherited version which could be from anywhere
    notificationPreference: Object,
    scopedNotificationPreference: Object,
    record: Object,
    showTimezoneSelect: Boolean,
    organizationScope: Object,
  },
  components: {
    LoadingSpinner: () => import('@/components/loading-spinner/loading-spinner'),
  },
  data() {
    return {
      partialUUID: uuid.v4(),
      defaultTimeZone: 'Eastern Time (US & Canada)',
      organization: null,
      timeZonesList: [],
      newNotificationPreference: null,
      hours: [],
      minutes: [],
      // Fun fact it is officially called a period: https://english.stackexchange.com/questions/35315/what-is-the-proper-name-for-am-and-pm2
      period: ['AM', 'PM'],
      selectedHour: 8,
      selectedMinute: '00',
      selectedPeriod: 'AM',
      finishedLoading: false,
      showTimezone: true,
      debugLog: false,
    };
  },
  mounted() {
    // Lets gen the minutes so I don't have to write out by hand
    for (let i = 0; i < 60; i += 1) {
      let label = `${i}`;
      if (i < 10) {
        label = `0${i}`;
      }
      this.minutes.push({label: label, value: i});
    }
    // Now gen the hours for the same reason
    for (let i = 0; i < 12; i += 1) {
      let label = `${i}`;
      if (i === 0) {
        label = `${12}`;
      }
      this.hours.push({label: `${label}`, value: i});
    }
    // Load baby load
    this.initialLoad();
  },
  methods: {
    reset() {
      this.showTimezone = true;
      this.finishedLoading = false;
      this.newNotificationPreference = null;
      this.timeZonesList = [];
      this.organization = null;
    },
    initialLoad() {
      this.reset();
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const outterParams = {timestamp: secondsSinceEpoch};

      this.log('notification-preference-partial -> initialLoad', 'record', this.record);
      this.log('notification-preference-partial -> initialLoad', 'scopedNotificationPreference', this.scopedNotificationPreference);
      this.log('notification-preference-partial -> initialLoad', 'notificationPreference', this.notificationPreference);
      this.log('notification-preference-partial -> initialLoad', 'showTimezoneSelect', this.showTimezoneSelect);
      if (this.record && this.scopedNotificationPreference && this.notificationPreference && this.organizationScope) {

        if (this.showTimezoneSelect === false) {
          this.showTimezone = false;
        }

        this.log('notification-preference-partial initialLoad', 'organizationScope', this.organizationScope);
        const organizationScopeId = this.getDefaultOrganizationId(this.organizationScope);

        if (organizationScopeId) {
          OrganizationService.show(organizationScopeId, outterParams).then(({data}) => {
            const organization = data;
            this.log('notification-preference-partial -> initialLoad -> OrganizationShow', 'organization', organization);
            if (organization && organization.attributes) {
              this.timeZonesList = _.cloneDeep(organization.attributes.available_time_zones);
              this.organization = organization;
              // this.log('notification-preference-partial -> initialLoad -> OrganizationShow -> TimeZone List', 'timeZonesList', this.timeZonesList);
            }
          });
        }
        this.newNotificationPreference = _.cloneDeep(this.scopedNotificationPreference);

        const [hour, minute, period] = this.convertMinutesToLocalTime(this.newNotificationPreference.minutes_since_midnight);
        if (hour) {
          this.selectedHour = hour;
        }
        if (minute) {
          this.selectedMinute = minute;
        }
        if (period) {
          this.selectedPeriod = period;
        }
        setTimeout(() => {
          this.finishedLoading = true;
        }, 100);
      }
    },
    /**
     * Because admin and learner app are slightly different we need to normalize it
     * @returns {*}
     */
    getDefaultOrganizationId(organizationScope = this.organizationScope) {
      let id = null;
      this.log('notification-preference-partial -> getDefaultOrganizationId', 'organizationScope', organizationScope);

      if (organizationScope) {
        if (organizationScope.id) {
          id = organizationScope.id;
        } else if (organizationScope.data.id) {
          id = organizationScope.data.id;
        }
      }
      this.log('notification-preference-partial -> getDefaultOrganizationId', 'id', id);

      return `${id}`;
    },
    convertMinutesToLocalTime(minutesSinceMidnight) {
      let hour = Math.floor(minutesSinceMidnight / 60);
      const minute = minutesSinceMidnight % 60;
      let period = 'AM';
      if (hour >= 12) {
        hour -= 12;
        period = 'PM';
      }
      // Because midnight is hour 0 they would want hour 12
      if (hour === 0) {
        hour = 12;
      }
      return [hour, minute, period];
    },
    convertLocalTimeToMinutes(selectedHour = 8, selectedMinutes = 0, selectedPeriod = 'AM') {
      this.log('notification-preference-partial updateMinutesSinceMidnight', 'minutesSinceMidnight', {
        selectedHour, selectedMinutes, selectedPeriod,
      });
      let hour = parseInt(selectedHour, 10);
      const minute = parseInt(selectedMinutes, 10);
      // if (selectedHour === 12) {
      //   hour = hour - 12;
      // }
      if (selectedPeriod === 'PM') {
        hour += 12;
      }
      return (hour * 60) + minute;
    },
    updateMinutesSinceMidnight() {
      const minutesSinceMidnight = this.convertLocalTimeToMinutes(this.selectedHour, this.selectedMinute, this.selectedPeriod);
      this.log('notification-preference-partial updateMinutesSinceMidnight', 'minutesSinceMidnight', minutesSinceMidnight);
      if (this.finishedLoading) {
        this.newNotificationPreference.minutes_since_midnight = minutesSinceMidnight;
        this.updatePreference();
      }
    },
    updatePreference() {
      this.log('notification-preference-partial update', 'update', {
        id: this.notificationPreference.id,
        preference: this.newNotificationPreference,
      });
      this.update(this.notificationPreference, this.newNotificationPreference);
    },
    updateTimeZone() {
      this.log('notification-preference-partial -> notificationPreference', 'notificationPreference', this.notificationPreference);
      let recordType;
      let recordId;
      if (this.notificationPreference.attributes) {
        recordType = this.notificationPreference.attributes.notification_preferable_type;
        recordId = this.notificationPreference.attributes.notification_preferable_id;
      } else {
        recordType = this.notificationPreference.notification_preferable_type;
        recordId = this.notificationPreference.notification_preferable_id;
      }
      this.log('notification-preference-partial -> updateTimeZone', 'recordType', recordType);
      if (recordType && recordId) {
        switch (recordType) {
          case 'V2::Member':
            this.updateUserTimeZone(recordId);
            break;
          case 'V2::Organization':
            this.updateOrganizationTimeZone(recordId);
            break;
          case 'V2::Syndicate':
            this.updateSyndicateTimeZone(recordId);
            break;
          default:
            this.logWarning('notification-preference-partial updateTimeZone', 'unknown recordType', recordType);
        }
        this.updatePreference();
      }
    },
    updateUserTimeZone(recordId) {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const outterParams = {timestamp: secondsSinceEpoch};
      this.log('notification-preference-partial updateUserTimeZone', 'recordId', recordId);
      MemberService.show(recordId, outterParams).then(({data}) => {
        this.log('notification-preference-partial updateUserTimeZone', 'member', data);
        if (data) {
          const userId = data.attributes.user_id;
          const params = {
            time_zone: this.newNotificationPreference.time_zone,
          };
          // eslint-disable-next-line no-shadow
          UserService.update(userId, params).then(({data}) => {
            this.log('notification-preference-partial updateUserTimeZone', 'user update', data);
          });
        }
      });
    },
    updateOrganizationTimeZone(recordId) {
      this.log('notification-preference-partial updateOrganizationTimeZone', 'recordId', recordId);
      const params = {
        time_zone: this.newNotificationPreference.time_zone,
      };
      OrganizationService.update(recordId, params).then((response) => {
        this.log('notification-preference-partial -> updateOrganizationTimeZone -> OrgServer Update', 'response', response);
      });
    },
    updateSyndicateTimeZone(recordId) {
      this.log('notification-preference-partial updateSyndicateTimeZone', 'recordId', recordId);
    },
    // eslint-disable-next-line func-names
    update: _.debounce((notificationPreference, newNotificationPreference) => {
      const notificationPreferenceId = notificationPreference.id;
      const params = {
        monday: newNotificationPreference.monday,
        tuesday: newNotificationPreference.tuesday,
        wednesday: newNotificationPreference.wednesday,
        thursday: newNotificationPreference.thursday,
        friday: newNotificationPreference.friday,
        saturday: newNotificationPreference.saturday,
        sunday: newNotificationPreference.sunday,
        inherited: false,
        minutes_since_midnight: newNotificationPreference.minutes_since_midnight,
        enabled: newNotificationPreference.enabled,
        time_zone: newNotificationPreference.time_zone,
      };
      NotificationPreferenceService.update(notificationPreferenceId, params);
    }, 500),
  },
};
</script>

<style scoped lang="scss" src="./style.scss">
</style>
